import http from 'plugins/axios';

export default {
  syncDoubleMiningConfig() {
    return http.get({
      url: '/la/admin/mining/miningDouble/initMiningCycleToRedis'
    });
  }
};
